import { IEnabledConfig, IMachine, IMachineStatus, IMachineValidations, IMechanicalConfig } from './iMachineTypes';

/**
 * Class representing a machine.
 * @class
 * @implements {IMachine}
 * The same object is diferent every where,
 * so don`t bother trying to create a specific type for machines or any other object
 */
export class Machine implements IMachine {
  id?: string;
  name?: string;
  brand?: string;
  enabled_config?: IEnabledConfig;
  gateway_SN?: string;
  gateway_id?: string;
  id_number?: string;
  mechanical_config?: IMechanicalConfig;
  other_brand?: string;
  production_line?: string;
  status?: IMachineStatus;
  type?: string;
  validations?: IMachineValidations;
  commission_number?: number;
  organization_id?: string;
  organization_name?: string;

  constructor(data: Partial<IMachine>) {
    Object.assign(this, data);
  }
}
